"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'app.pagination.pagnation_info': 'Mostrando {startItem} a {endItem} de {totalItems} entradas',
};
